import { Suspense, lazy } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { useLocaleHandler } from '@customer-complaints/i18n'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { useLocationStore } from '@shared/global-store/stores/location/location'

const App = lazy(() => import('@customer-complaints/App'))

const Loader = () => null

const Root = () => {
  const locationStore = useLocationStore()
  const isLoading = useLocaleHandler(locationStore.locale)

  return (
    <Suspense fallback={<Loader />}>
      <I18nProvider i18n={i18n}>
        <BrowserRouter
          basename={`/${locationStore.urlPrefix.urlPrefix}${import.meta.env.PUBLIC_BASENAME}`}
        >
          {isLoading ? <Loader /> : <App />}
        </BrowserRouter>
      </I18nProvider>
    </Suspense>
  )
}

export default Root
